import { render } from "./ComponentTextMining.vue?vue&type=template&id=284be290&scoped=true"
import script from "./ComponentTextMining.vue?vue&type=script&lang=js"
export * from "./ComponentTextMining.vue?vue&type=script&lang=js"

import "./ComponentTextMining.vue?vue&type=style&index=0&id=284be290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284be290"]])

export default __exports__